import React, { useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { setDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import EditEmployeeModal from '../../components/EditEmployeeModal';
import Icon from '../../components/Icon';

// Re-use the firebase config for the temporary app instance
const firebaseConfig = {
  apiKey: "AIzaSyCUsSWEQQtxawDPJzUKpwP3wKchE-9rwyA",
  authDomain: "mbbscompanion-internportal.firebaseapp.com",
  projectId: "mbbscompanion-internportal",
  storageBucket: "mbbscompanion-internportal.firebasestorage.app",
  messagingSenderId: "396731432941",
  appId: "1:396731432941:web:0bb344549e86995c7cb1e4"
};

const ManageEmployeesTab = ({ employees, setNotification }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);

    const handleCreateEmployee = async (e) => {
        e.preventDefault();
        const tempApp = initializeApp(firebaseConfig, "temp-for-creation");
        const tempAuth = getAuth(tempApp);

        try {
            const userCredential = await createUserWithEmailAndPassword(tempAuth, email, password);
            await setDoc(doc(db, "employees", userCredential.user.uid), { name, email });
            setName(''); setEmail(''); setPassword('');
            setNotification({ type: 'success', message: 'Employee created successfully!' });
        } catch (error) {
            setNotification({ type: 'error', message: `Error creating employee: ${error.message}` });
        } finally {
            await signOut(tempAuth);
        }
    };
    
    const handleDeleteEmployee = async (employeeId, employeeEmail) => {
        if (window.confirm(`Are you sure you want to delete ${employeeEmail}? This only removes them from the portal, but does not delete their login credentials.`)) {
            try {
                await deleteDoc(doc(db, "employees", employeeId));
                setNotification({ type: 'success', message: 'Employee record deleted from the portal.' });
            } catch (error) {
                setNotification({ type: 'error', message: 'Error deleting employee.' });
            }
        }
    };

    const openEditModal = (employee) => {
        setEditingEmployee(employee);
        setIsEditModalOpen(true);
    };
    
    return (
        <div>
            <EditEmployeeModal 
                isOpen={isEditModalOpen} 
                onClose={() => setIsEditModalOpen(false)} 
                employee={editingEmployee}
                setNotification={setNotification}
            />
            <div className="bg-white p-6 rounded-xl shadow-sm mb-8">
                <h3 className="text-xl font-bold text-slate-800 mb-4">Create New Employee</h3>
                <form onSubmit={handleCreateEmployee} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                    <input value={name} onChange={e => setName(e.target.value)} placeholder="Full Name" className="p-2 border rounded-md" required />
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="p-2 border rounded-md" required />
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" className="p-2 border rounded-md" required />
                    <button type="submit" className="col-span-1 md:col-span-3 bg-indigo-600 text-white font-semibold py-2 rounded-md hover:bg-indigo-700">Create</button>
                </form>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <table className="w-full text-left">
                    <thead className="bg-slate-50">
                        <tr>
                            <th className="p-4 font-semibold text-slate-600">Name</th>
                            <th className="p-4 font-semibold text-slate-600">Email</th>
                            <th className="p-4 font-semibold text-slate-600">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.map(emp => (
                            <tr key={emp.id} className="border-t">
                                <td className="p-4">{emp.name}</td>
                                <td className="p-4">{emp.email}</td>
                                <td className="p-4 flex gap-4">
                                    <button onClick={() => openEditModal(emp)} className="flex items-center gap-1 text-indigo-600 hover:text-indigo-800 text-sm font-medium">
                                        <Icon name="Edit" className="w-4 h-4" />
                                        Edit
                                    </button>
                                    <button onClick={() => handleDeleteEmployee(emp.id, emp.email)} className="flex items-center gap-1 text-red-500 hover:text-red-700 text-sm font-medium">
                                        <Icon name="Trash2" className="w-4 h-4" />
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ManageEmployeesTab;
